<template>
  <div v-if="column == 'DONE' && item.outputs && item.outputs.length">
    <span class="ml-4 caption grey--text text--darken-2">
      {{ $t('board.outputs') }}
    </span>
    <div class="ma-2">
      <v-tooltip v-for="output in item.outputs" :key="output.id" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip class="mx-1 my-1" small outlined>
            <span
              v-on="on"
              v-bind="attrs"
              class="mw-150 text-truncate primary--text caption"
              @click="openOutput(output.url)"
            >
              {{ output.name }}
            </span>
            <v-icon class="mt-1 ml-2" color="primary" x-small>
              mdi-tray-arrow-down
            </v-icon>
          </v-chip>
        </template>

        {{ output.name }}
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardOutputs',
  props: ['item', 'column'],
  methods: {
    openOutput(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
  .v-chip span {
    max-width: 200px !important;
  }

</style>